import SearchResults from './searchResults';

export default SearchResults;
